








import Vue from 'vue'
export default class Hamburger extends Vue{

    
}
